/* Compact chip rendered in the Seller column of the leads table. Shows the
 * most recent call outcome + "X ago" so wholesalers can see follow-up
 * urgency at a glance across the whole pipeline.
 */
import {
  PhoneCall, PhoneOff, Voicemail, Phone, AlertCircle, MessageCircle,
} from "lucide-react";
import { shortTimeAgo } from "@/lib/followUp";

// Outcome → icon + label + tailwind class for the chip background.
export const OUTCOME_META = {
  talked:       { Icon: PhoneCall,    label: "Talked",    cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  voicemail:    { Icon: Voicemail,    label: "Voicemail", cls: "text-sky-700 bg-sky-50 border-sky-200" },
  no_answer:    { Icon: PhoneOff,     label: "No answer", cls: "text-slate-700 bg-slate-50 border-slate-200" },
  busy:         { Icon: Phone,        label: "Busy",      cls: "text-amber-700 bg-amber-50 border-amber-200" },
  wrong_number: { Icon: AlertCircle,  label: "Wrong #",   cls: "text-rose-700 bg-rose-50 border-rose-200" },
  other:        { Icon: MessageCircle,label: "Other",     cls: "text-slate-700 bg-slate-50 border-slate-200" },
};

export function LastContactBadge({ lastCall, leadId }) {
  if (!lastCall) return null;
  const meta = OUTCOME_META[lastCall.outcome] || OUTCOME_META.other;
  const { Icon, label, cls } = meta;
  return (
    <div
      className={`inline-flex items-center gap-1 mt-1 px-1.5 py-0.5 rounded border text-[10px] font-semibold ${cls}`}
      title={`Last contacted ${shortTimeAgo(lastCall.created_at)}`}
      data-testid={`last-contact-badge-${leadId}`}
    >
      <Icon size={10} /> {label} · {shortTimeAgo(lastCall.created_at)}
    </div>
  );
}
